import React from "react";
import PdfListPage from "./PdfListPage";
import { usePoly } from "./PolyLayout";

export default function ImportantLinks() {
  const data = usePoly();
  return (
    <PdfListPage
      eyebrow="Resources"
      title="Important Links"
      accent="teal"
      items={data.links || []}
      testid="poly-links"
      emptyMsg="No important links have been published yet."
    />
  );
}
